
export const formatterhelper = {
    dateformatter,
    monthString,
    year  
};

function dateformatter({date}){
    const inputDate = new Date(date);

    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are zero-based
    const day = String(inputDate.getDate()).padStart(2, '0');
    
    const formattedDate = `${year}-${month}-${day}`; 
    return formattedDate;
}  


function monthString(date){
    try {
        let currentDate = '';
        if(date  != '' && date !== null && date !== undefined){
            currentDate = new Date(date);    
        }else{
            currentDate = new Date();
        }
        const month = new Intl.DateTimeFormat('en-US', {
        month: 'short'
        }).formatToParts(currentDate)[0].value; 
        return month; 
    } catch (error) {
        console.error('Error in getYear function:', error);
        // Return a default value or rethrow the error based on your use case
        throw error;
    } 
   
}



function year(date) {
    try {
        let currentDate = '';

        if (date !== '' && date !== null && date !== undefined) {
            currentDate = new Date(date);
        } else {
            currentDate = new Date();
        }

        const year_ = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
        }).formatToParts(currentDate)[0].value;

        return year_;
    } catch (error) {
        console.error('Error in getYear function:', error);
        // Return a default value or rethrow the error based on your use case
        throw error;
    }
}
